module.exports = __webpack_public_path__ + "img/shio2.59c0cf82.jpg";